exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VwQC{font-family:Roboto,sans-serif}._3_zuS,._3TB2M{width:600px}._2h0OF{font-size:18px;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}._2h0OF h5{color:#363636}._2h0OF h5 span{opacity:.5;display:block}._2wlBe{text-align:center;padding:40px}._2grFB{background-color:#fff;border:1px solid #e4002b;margin:0 20px;cursor:pointer;-webkit-appearance:initial!important;display:inline-block;padding:30px;width:200px}._2grFB,a._2grFB:hover{color:#e4002b;text-decoration:none}a._2grFB:hover{background-color:#f6f6f6}._2grFB i{font-size:40px}._2grFB p{margin:10px 0 0}._2KTEs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2KTEs button{width:140px;color:#fff;font-size:14px;background-color:#e4002b;cursor:pointer}._2KTEs button:hover{color:#ddd;background-color:#e4002b}._1sQ5P{color:#eee;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}", ""]);

// exports
exports.locals = {
	"modalFinalizado": "_2VwQC",
	"modalFinalizadoContent": "_3TB2M",
	"modalDialog": "_3_zuS",
	"modalHeader": "_2h0OF",
	"modalBody": "_2wlBe",
	"modalButtons": "_2grFB",
	"modalFooter": "_2KTEs",
	"boton_rojo": "_1sQ5P"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalFinalizado/ModalFinalizado.css
// module id = 1244
// module chunks = 0 1 2